const state = {
    msgErrorLogin: '',
    token: null,
    dateToken: null,
}

// mutations
const mutations = {
    updateMsgErrorLogin (state, newMsgErrorLogin) {
        state.msgErrorLogin = newMsgErrorLogin;
    },
    updateToken (state, newToken) {
        state.token = 'Bearer '+newToken;
        state.dateToken = new Date().getTime();
    },
    clearToken (){
        state.token = null;
        state.dateToken = null;
    },
}

export default {
    state,
    mutations
}